import { DataGrid, GRID_DEFAULT_LOCALE_TEXT } from '@mui/x-data-grid';
import { styled } from '@mui/system';

// Grilla compartida (estilo de Personal) para unificar tablas de la app.
export const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: '#f5f5f5',  // Fondo gris claro para el encabezado
    color: theme.palette.text.primary,  // Texto oscuro (basado en el color de texto principal del tema)
    textAlign: 'center',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 'bold', // Texto en negrita en los encabezados
  },
  '& .MuiDataGrid-cell': {
    borderBottom: '1px solid #e0e0e0',
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: '#f1f1f1',
  },
  '& .MuiDataGrid-virtualScroller': {
    overflow: 'hidden !important',
  },
  '& .MuiDataGrid-root': {
    overflowX: 'hidden',
  },
  '& .MuiDataGrid-main': {
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      width: 0,
      height: 0,
    },
  },
  '& .inactive-row': {
    backgroundColor: '#ffebee !important',
    '&:hover': {
      backgroundColor: '#ffcdd2 !important',
    },
  },
}));

// Traducción personalizada al español
export const customLocaleText = {
  ...GRID_DEFAULT_LOCALE_TEXT,
  MuiTablePagination: {
    labelRowsPerPage: 'Filas por página:',
    labelDisplayedRows: ({ from, to, count }) =>
      `${from}–${to} de ${count !== -1 ? count : `más de ${to}`}`,
  },
  columnMenuSortAsc: 'Ordenar ascendente',
  columnMenuSortDesc: 'Ordenar descendente',
  columnMenuFilter: 'Filtrar',
  columnMenuHideColumn: 'Ocultar columna',
  columnMenuShowColumns: 'Mostrar columnas',
  footerRowSelected: (count) => `${count.toLocaleString()} fila(s) seleccionada(s)`,
  footerTotalRows: 'Total de filas:',
  noRowsLabel: 'No se encontraron datos.',
  toolbarDensity: 'Densidad',
  toolbarDensityLabel: 'Densidad',
  toolbarDensityCompact: 'Compacta',
  toolbarDensityStandard: 'Estándar',
  toolbarDensityComfortable: 'Cómoda',
  toolbarColumns: 'Columnas',
  toolbarColumnsLabel: 'Seleccionar columnas',
  toolbarFilters: 'Filtros',
  toolbarFiltersLabel: 'Mostrar filtros',
  toolbarFiltersTooltipHide: 'Ocultar filtros',
  toolbarFiltersTooltipShow: 'Mostrar filtros',
  toolbarFiltersTooltipActive: (count) => `${count} filtro(s) activo(s)`,
  toolbarExport: 'Exportar',
  toolbarExportLabel: 'Exportar',
  toolbarExportCSV: 'Descargar como CSV',
};
